import { render, staticRenderFns } from "./OrderDeploy.vue?vue&type=template&id=4ae0a120&scoped=true&"
import script from "./OrderDeploy.vue?vue&type=script&lang=ts&"
export * from "./OrderDeploy.vue?vue&type=script&lang=ts&"
import style0 from "./OrderDeploy.vue?vue&type=style&index=0&id=4ae0a120&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae0a120",
  null
  
)

export default component.exports